export const InvalidLink = () => (
  <div className="min-h-screen flex items-center justify-center px-6" data-testid="invalid-link-page">
    <div className="text-center max-w-md">
      <div className="text-5xl mb-4 font-display font-semibold text-[#6C8EAD]">Link non valido</div>
      <p className="text-[#5B6E78]">
        Il link utilizzato non è attivo o non esiste. Verifica l'indirizzo e riprova.
      </p>
    </div>
  </div>
);
